export enum EnumTipoCodigoEspecificacao {
  ITEM = 1,
  SIGA = 2,
}
